import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent, SpinnerComponent } from '@mzic/mzic-components';
import { CollectionRevisionNavigationIntent } from '../../collection-flow/collection-revision-file-editor';

@Component({
  selector: 'lib-file-update-confirmation-dialog',
  imports: [
    CommonModule,
    A11yModule,
    TranslocoModule,
    MzicSvgComponent,
    SpinnerComponent,
  ],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './file-update-confirmation-dialog.component.html',
  styleUrl: './file-update-confirmation-dialog.component.scss',
})
export class FileUpdateConfirmationDialogComponent implements AfterViewInit {
  @Input({ required: true }) direction!: CollectionRevisionNavigationIntent;
  @Input() canUpdate = true;
  @Input() busy = false;
  @Output() updateFiles = new EventEmitter<void>();
  @Output() discardChanges = new EventEmitter<void>();
  @Output() stay = new EventEmitter<void>();

  @ViewChild('primaryButton', { read: ElementRef })
  private primaryButton?: ElementRef<HTMLButtonElement>;

  readonly titleId = 'file-update-confirmation-title';
  readonly descriptionId = 'file-update-confirmation-description';

  get updateActionKey(): string {
    return this.direction === 'BACK'
      ? 'lang.file_update_confirmation_update_back'
      : this.direction === 'NEXT'
        ? 'lang.file_update_confirmation_update_next'
        : 'lang.file_update_confirmation_update_leave';
  }

  get discardActionKey(): string {
    return this.direction === 'BACK'
      ? 'lang.file_update_confirmation_discard_back'
      : this.direction === 'NEXT'
        ? 'lang.file_update_confirmation_discard_next'
        : 'lang.file_update_confirmation_discard_leave';
  }

  ngAfterViewInit(): void {
    this.primaryButton?.nativeElement.focus();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    if (this.busy) return;
    event.preventDefault();
    this.stay.emit();
  }

  onOverlayClick(event: Event): void {
    if (!this.busy && event.target === event.currentTarget) {
      this.stay.emit();
    }
  }

  onUpdateFiles(): void {
    if (!this.busy && this.canUpdate) this.updateFiles.emit();
  }

  onDiscardChanges(): void {
    if (!this.busy) this.discardChanges.emit();
  }
}
